var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCalendar = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57068 6.66667H12.5967M5.57068 9.33333H9.0837M5.57068 2V3.33333M12.5967 2V3.33333M5.00859 14H13.1588C13.9458 14 14.3393 14 14.6399 13.8547C14.9043 13.7269 15.1193 13.5229 15.254 13.272C15.4072 12.9868 15.4072 12.6134 15.4072 11.8667V5.46667C15.4072 4.71993 15.4072 4.34656 15.254 4.06135C15.1193 3.81046 14.9043 3.60649 14.6399 3.47866C14.3393 3.33333 13.9458 3.33333 13.1588 3.33333H5.00859C4.2216 3.33333 3.8281 3.33333 3.52751 3.47866C3.2631 3.60649 3.04813 3.81046 2.91341 4.06135C2.76025 4.34656 2.76025 4.71993 2.76025 5.46667V11.8667C2.76025 12.6134 2.76025 12.9868 2.91341 13.272C3.04813 13.5229 3.2631 13.7269 3.52751 13.8547C3.8281 14 4.2216 14 5.00859 14Z",
    stroke: "#2E2BEB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.a6bde7e3.svg";
export { ForwardRef as ReactComponent };